import { Button, CircularProgress } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import { clinicId } from "../../../constants";
import { useParams } from "react-router-dom";
import { useMutation } from "react-query";
import { AttendedLeaveCertificate } from "./services";
import moment from "moment";
import usePopup from "../../../hooks/usePopup";
import usePrint from "../../../hooks/usePrint";
import useAuthentication from "@hooks/useAuthentication";

function AttentandLeaveForm() {
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const { control, handleSubmit, reset } = useForm();
  const { encounterId } = useParams();
  const {printPdf} = usePrint()
  const { mutate, isLoading } = useMutation(AttendedLeaveCertificate, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success" && result.response) {
        printPdf(result.response)
      }
      reset();
    },
  });
  const onSubmit = (data: any) => {
    const isValidDate = moment(data.fromDate, "YYYY-MM-DD").isSameOrBefore(
      data.toDate,
      "day"
    );
    if (isValidDate) {
      const body = {
        clinicId: clinicId,
        encounterId: parseInt(encounterId as string),
        from: data.fromDate, // Assuming it's a date in "DD/MM/YYYY" format
        to: data.toDate,
        createdById: Number(user?.userId),
      };
      mutate(body);
    } else {
      showSnackbar({
        message: "Invalid TO DATE !",
        open: true,
        variant: "warning",
        duration: 2000,
      });
    }
  };

  const handleReset = () => {
    reset();
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-3 gap-3">
      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "From date" }}
        name="fromDate"
        rules={{ required: "From date required" }}
      />
      <CustomFormField
        control={control}
        element="datepicker"
        fieldProps={{ label: "To date" }}
        name="toDate"
        rules={{ required: "From date required" }}
      />

      <div className="flex gap-x-2  items-center">
        <Button
          type="submit"
          color="success"
          disabled={isLoading}
          endIcon={isLoading && <CircularProgress size={18} color="success" />}
        >
          submit
        </Button>
        <Button color="error" onClick={handleReset}>reset</Button>
      </div>
    </form>
  );
}

export default AttentandLeaveForm;
